var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"radio",class:{ 'active' : _vm.data},on:{"click":_vm.changeValue}},[_c('span',[_vm._v("Other")])])
}
var staticRenderFns = []

export { render, staticRenderFns }